import { ItemType, PricingSheetRow } from "./types";

const isRental = (item: PricingSheetRow) => item.type === ItemType.Rental;

const safeCompareOfferItemId = (
  a: { offerItemId?: number },
  b: { offerItemId?: number },
): number => {
  // Undefined are set to max, so defined values comes first
  const aId = a.offerItemId ?? Number.MAX_SAFE_INTEGER;
  const bId = b.offerItemId ?? Number.MAX_SAFE_INTEGER;
  return aId - bId;
};

export const sortByItemType = (
  a: PricingSheetRow | undefined,
  b: PricingSheetRow | undefined,
) => {
  if (a && b) {
    // rental items come first
    if (isRental(b) && !isRental(a)) return -1;
    if (!isRental(b) && isRental(a)) return 1;
    if (b.type === a.type) {
      if (a.id === b.id && a.id >= 0 && b.id >= 0) {
        return b.pricingBasis.localeCompare(a.pricingBasis);
      }
      // additionally sort rental and sales items first by catClass, then by db row id
      return (
        b.catClass.localeCompare(a.catClass) || safeCompareOfferItemId(a, b)
      );
    }
  }
  return 0;
};
